import translationKeys from '../translationKeys'

export default {
  [translationKeys.ADMINISTRATOR]: 'Administrator',
  [translationKeys.COMMON_OK]: 'Ok',
  [translationKeys.COMMON_GO_BACK]: 'Back',
  [translationKeys.COMMON_CLOSE]: 'Close',
  [translationKeys.MAIN_LOGO_ALT_TEXT]: 'PartneringOne+',
  [translationKeys.PARTNERING_ONE_TEXT]: 'partneringONE',
  [translationKeys.HEADER_HOME_ICON_ALT_TEXT]: 'Home',
  [translationKeys.SEARCH_LABEL]: 'Search',
  [translationKeys.SEARCH_FILTER_BY_DELEGATES]: 'Delegate',
  [translationKeys.SEARCH_FILTER_BY_COMPANIES]: 'Companies',
  [translationKeys.SEARCH_FILTER_PLACEHOLDER]: '<b>Enter a search term</b> or <b>select a filter</b> to start your search',
  [translationKeys.SEARCH_FILTER_BY_COMPANY_ASSETS]: 'Company Assets',
  [translationKeys.SEARCH_FILTER_BY_ALL_CATEGORIES]: 'All',
  [translationKeys.SEARCH_FILTERS_TITLE]: 'FILTERS',
  [translationKeys.SEARCH_NO_RESULTS]: 'No search results, please try another query',
  [translationKeys.SEARCH_RESET_QUERY]: 'Reset the query',
  [translationKeys.SEARCH_RESET_SEARCH_BUTTON]: 'Reset all',
  [translationKeys.SEARCH_RESULT_TITLE]: 'Results ({{resultCount}})',
  [translationKeys.SAVE_SEARCH_BUTTON]: 'Save search',
  [translationKeys.SEARCH_NAME_LABEL]: 'Name of saved search',
  [translationKeys.SEARCH_FORM_LABEL]: 'Add email notification',
  [translationKeys.SEARCH_NO_NOTIFICATION]: 'No notification',
  [translationKeys.SAVE_SEARCH_TITLE]: 'Save search',
  [translationKeys.SAVED_SEARCHES]: 'Saved searches',
  [translationKeys.SAVED_SEARCH]: 'Saved search',
  [translationKeys.SAVED_SEARCHES_NAME]: 'Name',
  [translationKeys.SAVED_SEARCHES_NEW]: 'New',
  [translationKeys.SAVED_SEARCHES_SEARCH]: 'Search',
  [translationKeys.SAVED_SEARCHES_NOTIFICATION]: 'Notifications',
  [translationKeys.SAVED_SEARCHES_RUN]: 'Run',
  [translationKeys.SEARCH_FORM_ALERT]: 'Add email notification',
  [translationKeys.SEARCH_MENU_DAILY]: 'Daily',
  [translationKeys.SEARCH_MENU_WEEKLY]: 'Weekly',
  [translationKeys.SEARCH_ADD_TO_ALERTS_BTN]: 'Add to alerts ',
  [translationKeys.SEARCH_FILTER_BY_DATE]: 'Filter by date',
  [translationKeys.SEARCH_FILTER_BY_DATE_TO]: 'To',
  [translationKeys.SEARCH_FILTER_BY_DATE_FROM]: 'From',
  [translationKeys.SEARCH_FILTER_BY_DATE_LABEL]: 'Filter by date',
  [translationKeys.SEARCH_FILTER_BY_EVENT]: 'Event',
  [translationKeys.SEARCH_FILTER_BY_EVENT_TOOLTIP]:
    'This event was imported from an external source and is only visible to your team',
  [translationKeys.SEARCH_FILTER_BY_EVENT_LABEL]: 'By event',
  [translationKeys.SEARCH_FILTER_BY_RECENT_LABEL]: 'Recent items',
  [translationKeys.SEARCH_FILTER_BY_DATE_LABEL_EMPTY]: 'No filter applied',
  [translationKeys.SEARCH_FILTER_BY_RECENT]: 'Recent',
  [translationKeys.SEARCH_FILTER_BY_RECENT_WEEK]: 'Last week',
  [translationKeys.SEARCH_FILTER_BY_RECENT_MONTH]: 'Last month',
  [translationKeys.SEARCH_FILTER_BY_RECENT_THREE_MONTHS]: 'Last 3 months',
  [translationKeys.SEARCH_FILTER_BY_DATE_RANGE]: 'Date range',
  [translationKeys.NEW_ITEMS_LABEL]: 'New profiles only',
  [translationKeys.NEW_ITEMS_DESCRIPTION]: 'Show only profiles added since the last run of this search',
  [translationKeys.SEARCH_FILTER_BY_DATE_SUBMIT]: 'Submit',
  [translationKeys.SEARCH_FILTER_META_CLOSE]: 'Close',
  [translationKeys.SEARCH_FILTER_SELECT_SUBMIT]: 'Go',
  [translationKeys.SEARCH_FILTER_SECTION_SEE_MORE]: 'See more',
  [translationKeys.SEARCH_FILTER_SECTION_SEE_LESS]: 'See less',
  [translationKeys.SEARCH_GROUP_BY]: 'Group by',
  [translationKeys.SEARCH_BY_HISTORY]: 'History',
  [translationKeys.DEFAULT_BY_EVENT]: 'Filter by event',
  [translationKeys.SEARCH_BY_EVENT]: 'Event',
  [translationKeys.FILTER_BY_MULTIPLE]: 'Multiple',
  [translationKeys.FILTER_BY_ALL]: 'All',
  [translationKeys.FILTER_BY_EXCLUDE]: 'Exclude',
  [translationKeys.GROUP_BY_COMPANY]: 'Company',
  [translationKeys.NO_GROUPING]: 'No grouping',
  [translationKeys.SEARCH_SORT_BY]: 'Sort by',
  [translationKeys.SEARCH_HISTORY_FILTER_REMOVE]: '-- Remove filter --',
  [translationKeys.SEARCH_HISTORY_FILTER_MY_MEETINGS]: 'My meetings',
  [translationKeys.SEARCH_HISTORY_FILTER_PERSONAL]: 'Personal history',
  [translationKeys.SEARCH_HISTORY_FILTER_COMPANY_HISTORY]: 'Company history',
  [translationKeys.SEARCH_HISTORY_FILTER_NO_HISTORY]: 'No history',
  [translationKeys.SEARCH_RESULT_COMPANY_LOGO_ALT]: 'Company Logo',
  [translationKeys.CONTACT_BUTTON]: 'Contact',
  [translationKeys.EXISTING_CONVERSATION]: 'Existing conversation',
  [translationKeys.SEARCH_RESULTS_ITEM_READ_MORE_BTN]: 'Read more',
  [translationKeys.COMPANY_PROFILE_BTN]: 'See the full company profile',
  [translationKeys.ASSET_BIOTECH_SHORT_NAME]: 'Biotech',
  [translationKeys.ASSET_MEDTECH_SHORT_NAME]: 'Medtech',
  [translationKeys.ASSET_SERVICES_SHORT_NAME]: 'Services',
  [translationKeys.ASSET_TECHNOLOGIES_SHORT_NAME]: 'Technologies',
  [translationKeys.SORT_MOST_RECENT]: 'Most recent ↑',
  [translationKeys.SORT_LEAST_RECENT]: 'Least recent ↓',
  [translationKeys.SORT_TEXT_BOTTOM]: 'A-Z',
  [translationKeys.SORT_TEXT_UP]: 'Z-A',
  [translationKeys.CONFIRM_BUTTON]: 'Confirm',
  [translationKeys.CANCEL_BUTTON]: 'Cancel',
  [translationKeys.DELETE_BUTTON]: 'Delete',
  [translationKeys.DELETE_SINGLE_SAVED_SEARCH]: 'Are you sure you want to delete this saved search?',
  [translationKeys.DELETE_MULTIPLE_SAVED_SEARCHES]: 'Are you sure you want to delete these saved searches?',
  [translationKeys.DELETE_SAVED_SEARCH]: 'Delete saved search',
  [translationKeys.SAVE]: 'Save',
  [translationKeys.REMOVE_ALL]: 'Remove all',
  [translationKeys.REMOVE]: 'Remove',
  [translationKeys.SETTINGS]: 'Settings',
  [translationKeys.LOGOUT]: 'Logout',
  [translationKeys.UNSAVED_SETTINGS]: 'Unsaved settings',
  [translationKeys.YOU_HAVENOT_SAVED_CHANGES]: 'You haven’t saved the changes on this popup',
  [translationKeys.CONTINUE_EDITING]: 'Continue editing',
  [translationKeys.CLOSE_ANYWAY]: 'Close anyway',
  [translationKeys.SEARCH_PLACEHOLDER_SUBSCRIBER_HEADING]: 'Search the entire database or focus on a few events',
  [translationKeys.SEARCH_PLACEHOLDER_FREE_HEADING]: 'Search across all of your events',
  [translationKeys.SEARCH_PLACEHOLDER_TIPS_HEADING]: 'Quick search tips',
  [translationKeys.SEARCH_PLACEHOLDER_SUBSCRIBER_TIPS_1]: 'Top tip – plan ahead by browsing profiles from upcoming events',
  [translationKeys.SEARCH_PLACEHOLDER_SUBSCRIBER_TIPS_2]: 'Start by entering a search term and filter combinations',
  [translationKeys.SEARCH_PLACEHOLDER_SUBSCRIBER_TIPS_3]: 'Focus your search results by recency or event',
  [translationKeys.SEARCH_PLACEHOLDER_SUBSCRIBER_TIPS_4]: 'Free-text search results are ordered by relevancy',
  [translationKeys.SEARCH_PLACEHOLDER_FREE_TIPS_1]: 'Start by entering a search term and filter combinations',
  [translationKeys.SEARCH_PLACEHOLDER_FREE_TIPS_2]: 'Focus your search results by recency',
  [translationKeys.SEARCH_PLACEHOLDER_FREE_TIPS_3]: 'Free-text search results are ordered by relevancy',
  [translationKeys.SEARCH_PLACEHOLDER_OPERATORS]: 'Operators',
  [translationKeys.SEARCH_PLACEHOLDER_OPERATORS_TIPS_1]: 'Use “quote marks” to find exact phrases',
  [translationKeys.SEARCH_PLACEHOLDER_OPERATORS_TIPS_2]: 'Use AND to include terms',
  [translationKeys.SEARCH_PLACEHOLDER_OPERATORS_TIPS_3]: 'Use NOT to exclude terms',
  [translationKeys.SEARCH_PLACEHOLDER_OPERATORS_TIPS_4]: 'Use OR to find either terms',
  [translationKeys.SEARCH_PLACEHOLDER_OPERATORS_TIPS_EXAMPLE_1]: 'e.g. “Women’s health”',
  [translationKeys.SEARCH_PLACEHOLDER_OPERATORS_TIPS_EXAMPLE_2]: 'e.g. Oncology AND respiratory',
  [translationKeys.SEARCH_PLACEHOLDER_OPERATORS_TIPS_EXAMPLE_3]: 'e.g. Gastrointestinal NOT Gallstones',
  [translationKeys.SEARCH_PLACEHOLDER_OPERATORS_TIPS_EXAMPLE_4]: 'e.g. Cell OR Antibody',
  [translationKeys.ATTENDING]: 'Attending:',
  [translationKeys.SIGN_UP_TO]: 'Sign up to',
  [translationKeys.SEND_TO_ALL]: 'Send to all',
  [translationKeys.COMPANY_MESSAGE]: 'Company message',
  [translationKeys.TERMS]: 'Terms',
  [translationKeys.PRIVACY]: 'Privacy',
  [translationKeys.NAME_ALREADY_EXISTS]: 'Name already exists',
  [translationKeys.DO_YOU_WANT_TO_REWRITE_SAVE]: 'Do you want to overwrite your saved search?',
  [translationKeys.YOU_HAVE_SAVED_YOUR_SEARCH]: 'You have successfully saved your search parameters',
  [translationKeys.SEE_ALL_MESSAGES]: 'See all messages',
  [translationKeys.YOU_CAN_RUN_ANY_SAVED_PARAMS]: 'Select the saved search that you want to execute',
  [translationKeys.SAVE_SEARCH_PARAMS]: 'You need to select one or more items in order to delete them',
  [translationKeys.NEW]: 'New',
  [translationKeys.MARK_AS_READ]: 'Mark as read ✓',
  [translationKeys.MARK_ALL_AS_READ]: 'Mark all as read ✓',
  [translationKeys.MARK_ALL_AS_READ_WITHOUT_CHECKMARK]: 'Mark all as read',
  [translationKeys.UPDATED]: 'Updated',
  [translationKeys.NEW_ACTIVITY]: 'New activity',
  [translationKeys.PRIVATE_COMPANY_INDICATOR_TEXT]:
    'This profile was imported from an external source and is only visible to your team',
  [translationKeys.UPDATES]: 'Updates',
  [translationKeys.MANAGE_ALERTS]: 'Manage alerts',
  [translationKeys.MANAGE_ALERTS_ITEMS_TOTAL]: '{{count}} items',
  [translationKeys.UPDATES_TABLE_HEADER_ITEM]: 'Item',
  [translationKeys.UPDATES_TABLE_HEADER_ITEM]: 'Item',
  [translationKeys.UPDATES_TABLE_HEADER_UPDATES]: 'Updates',
  [translationKeys.UPDATES_TABLE_HEADER_LAST_UPDATED]: 'Last updated',
  [translationKeys.UPDATES_TABLE_HEADER_READ]: 'Read',
  [translationKeys.MANAGE_ALERTS_HEADER_ALERT_ADDED]: 'Alert added',
  [translationKeys.MANAGE_ALERTS_HEADER_FREQUENCY]: 'Email frequency',
  [translationKeys.SUCCESSFULLY_SAVED_PROSPECTS_TO_SEARCH_TITLE]: 'Any prospects not already in this list have been added',
  [translationKeys.SUCCESSFULLY_SAVED_PROSPECTS_TO_SEARCH_SUBTEXT]:
    'Some prospects may already be in your custom list, duplicates will not be added.',
  [translationKeys.FAILED_TO_SAVE_PROSPECTS_TO_SEARCH]: 'Failed to save prospects to custom list',
  [translationKeys.SUCCESSFULLY_SAVED_ALL_PROSPECTS_TO_SEARCH_TITLE]: 'All prospects have been added to a new custom list',
  [translationKeys.UNDO]: 'Undo',
  [translationKeys.SUCCESSFULLY_UNDO_SAVE_PROSPECTS_TO_SEARCH_TITLE]:
    "Any prospects that weren't already in this list have been removed",
  [translationKeys.FAILED_TO_UNDO_SAVE_PROSPECTS_TO_SEARCH_TITLE]: 'Failed to undo save',
  [translationKeys.START]: 'Start',
  [translationKeys.END]: 'End',
  [translationKeys.BETWEEN]: 'Is between',
  [translationKeys.NO_FILTER_APPLIED]: 'No filter applied',
  [translationKeys.SEARCH_BY_PROFILE_UPDATED]: 'Profile updated',
  [translationKeys.MULTIPLE_EVENTS_FILTERED]: 'Events: multiple',
  [translationKeys.PROFILES_FILTER_TITLE]: 'Profile Types',
  [translationKeys.SAVE_TO_CUSTOM_LIST]: 'Save to custom list',
}
